import { useEffect, useState } from "react";
import { waitlistApi } from "../lib/waitlistApi";

export const useWaitlistSummary = (pollMs = 60000) => {
    const [summary, setSummary] = useState(null);
    useEffect(() => {
        let cancelled = false;
        const fetch = async () => {
            try {
                const s = await waitlistApi.summary();
                if (!cancelled) setSummary(s);
            } catch (_) { /* silencioso */ }
        };
        fetch();
        const t = setInterval(fetch, pollMs);
        return () => { cancelled = true; clearInterval(t); };
    }, [pollMs]);
    return summary;
};

export default useWaitlistSummary;
